import { AdminEventRulesService } from '@/services';
import type { EventRuleCreateRequest as EventRulePayload } from '@/services';
import type { EventRuleUpdateRequest as EventRuleUpdatePayload } from '@/services';

export const getEventRules = () => {
  return AdminEventRulesService.listEventRulesAdminEventRulesGet();
};

export const getStreakTargets = () => {
  return AdminEventRulesService.listStreakTargetsAdminEventRulesStreakTargetsGet();
};

export const createEventRule = (body: EventRulePayload) => {
  return AdminEventRulesService.createEventRuleAdminEventRulesPost(body);
};

export const updateEventRule = (
  ruleId: string,
  body: EventRuleUpdatePayload
) => {
  return AdminEventRulesService.updateEventRuleAdminEventRulesRuleIdPatch(
    ruleId,
    body
  );
};

export const deleteEventRule = (ruleId: string) => {
  return AdminEventRulesService.deleteEventRuleAdminEventRulesRuleIdDelete(
    ruleId
  );
};

// A selectable Streak Alert target (backend source of truth): a named
// (trigger_event_type, condition) preset the UI offers so the "missed call"
// outcome list is never hardcoded here — it stays in sync with the backend
// outcome vocabulary and the analytics.
export type { StreakTargetDTO as StreakTargetResponse } from '@/services';
export type { EventRulesListResponse } from '@/services';
export type { EventRuleAdminDTO as EventRuleResponse } from '@/services';
export type { EventRuleUpdatePayload, EventRulePayload };
